module.exports = __webpack_public_path__ + "img/python.400f3995.svg";